import { http } from './http';

export interface ApiFieldModel {
  id: number;
  fieldModelName: string;
  fieldModelDescription: string;
  fieldModelType: string;
  FieldModelName?: string; FieldModelDescription?: string; FieldModelType?: string;
}
export interface ApiField {
  id: number;
  fieldModelId: number;
  fieldName: string;
  fieldDataType: string;
  fieldLength: number;
  fieldRequired: boolean;
  fieldRegExp?: string;
  fieldOffset?: string;
  fieldMask?: string;
	fieldTitle?: string;
	fieldDatatypeName?: string;
  fieldDatabaseDataType?: string;
  fieldShowInSearch?: boolean;
  fieldShowInDataGrid?: boolean;
  fieldGroup?: string;
  fieldUseAsSortingVar?: string;
  fieldIsUniqueFolderIndex?: boolean;
  fieldIsUniqueDocumentIndex?: boolean;
  fieldControlXMLLookupPath?: string;
  fieldControlOrderBy?: number;
  fieldLookupSQL?: string;
  FieldModelId?: number; FieldName?: string; FieldDataType?: string; FieldLength?: number; FieldRequired?: boolean; FieldRegExp?: string; FieldOffset?: string; FieldMask?: string; FieldTitle?: string; FieldDatabaseDataType?: string; FieldShowInSearch?: boolean; FieldShowInDataGrid?: boolean; FieldGroup?: string; FieldUseAsSortingVar?: string; FieldIsUniqueFolderIndex?: boolean; FieldIsUniqueDocumentIndex?: boolean; FieldControlXMLLookupPath?: string; FieldControlOrderBy?: number; FieldLookupSQL?: string;
}
function normalizeFieldModel(m:any): ApiFieldModel { if (m.FieldModelName && !m.fieldModelName) m.fieldModelName = m.FieldModelName; if (m.FieldModelDescription && !m.fieldModelDescription) m.fieldModelDescription = m.FieldModelDescription; if (m.FieldModelType && !m.fieldModelType) m.fieldModelType = m.FieldModelType; return m as ApiFieldModel; }
function normalizeField(f:any): ApiField {
  const map=(s:string,d:string)=>{ if(f[s]!==undefined && f[d]===undefined) f[d]=f[s];};
  ['FieldModelId','FieldName','FieldDataType','FieldLength','FieldRequired','FieldRegExp','FieldOffset','FieldMask','FieldTitle','FieldDatabaseDataType','FieldShowInSearch','FieldShowInDataGrid','FieldGroup','FieldUseAsSortingVar','FieldIsUniqueFolderIndex','FieldIsUniqueDocumentIndex','FieldControlXMLLookupPath','FieldControlOrderBy','FieldLookupSQL']
    .forEach(k=>map(k,k.charAt(0).toLowerCase()+k.slice(1)));
  return f as ApiField;
}

export async function getFieldModels(): Promise<ApiFieldModel[]> { const data = await http<any[]>('/api/fieldmodel'); return Array.isArray(data)? data.map(normalizeFieldModel):[]; }
export async function addFieldModel(model: Omit<ApiFieldModel,'id'>): Promise<ApiFieldModel> { return normalizeFieldModel(await http('/api/fieldmodel',{method:'POST', json:model})); }
export async function updateFieldModel(id:number, model: Omit<ApiFieldModel,'id'>): Promise<void> { await http(`/api/fieldmodel/${id}`,{method:'PUT', json:model}); }
export async function deleteFieldModel(id:number): Promise<void> { await http(`/api/fieldmodel/${id}`,{method:'DELETE'}); }
export async function getFieldsByModel(fieldModelId:number): Promise<ApiField[]> { const data = await http<any[]>(`/api/field/bymodel?fieldModelId=${fieldModelId}`); return Array.isArray(data)? data.map(normalizeField):[]; }
export async function addField(field: Omit<ApiField,'id'>): Promise<ApiField> { return normalizeField(await http('/api/field',{method:'POST', json:field})); }
export async function updateField(id:number, field: Omit<ApiField,'id'>): Promise<void> { await http(`/api/field/${id}`,{method:'PUT', json:field}); }
export async function deleteField(id:number): Promise<void> { await http(`/api/field/${id}`,{method:'DELETE'}); }
